












































import Upload from '@/views/purchaser/common/upload.vue';
import Vuedraggable from "vuedraggable";
import {  uploadFile } from '@/utils/api';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import {
  GoodsImgsInterface
} from '../interface';
@Component({
  components: {
    Vuedraggable
  }
})
export default class UploadImage extends Vue {

  /**
   *接收商品数据
   *
   */
  @Prop({ type: Array, default: [] })
  imgs!: Array<object>

   /**
   *监听外部进来的图片数据
   *
   */
  @Watch('imgs', { immediate: true, deep: true })
  valChange(newValue: Array<GoodsImgsInterface>, oldValue: Array<GoodsImgsInterface>): void {
    this.images = [...newValue];
    let filters=[];//原数据图片
    newValue.forEach(item=>{
      filters.push({status:'success',response:{fileUrl:item['imageUrl']}})
    })
    this.fileList=filters;
  }

  /**
   *监听外部进来的图片数据
   *
   */
  @Watch('fileList', { deep: true })
  fileListChange(newValue, oldValue): void {
    let list = [...newValue]
    for(let item of newValue) {
      if(item.status === 'success') {
        item['imageUrl'] = item.response.fileUrl
        item['sortId'] = 0
      }

    }
    this.images = list
  }

  /**
   *组件字段定义
   *
   */
  dialogFormVisible: boolean = true
  dragOptions: object = {
      animation: 300,
      group: "description",
      ghostClass: "ghost"
  }
  drag: boolean = false
  images: Array<GoodsImgsInterface> = []
  ruleForm: object = {}
  fileList: Array<object> = []
  loading: boolean = false;
  uploadUrl: string = process.env.NODE_ENV === 'development' ? `/bff-supplier/supplier/file/uploadFile` : `${location.origin}/api/bff-supplier/supplier/file/uploadFile`;
  uploadHeaders: object = {} //上传请求头
  mounted() {
    let authToken = localStorage.getItem('authToken')
    if (authToken) {
      this.uploadHeaders["Authorization"] = `Bearer ${authToken}`;
    }
  }
  
  onClickOut(): void {
    this.$emit('close')
  }

  onClick(): void{
    this.$emit('uploadConfirm', this.images)
    this.$emit('close')
  }

  /**
   *删除图片
   *
   */
  deleteImg(index): void {
    this.images.splice(index, 1);
    this.fileList.splice(index, 1);
  }

  /**
   *上传文件发生改变
   *
   */
  handleChange(file, fileList2) {
    this.fileList = fileList2
  }

  /**
   *上传前校验
   *
   */
  beforeAvatarUpload(file) {
    const isJPG = file.type === 'image/jpeg';
    const isPNG = file.type === 'image/png';
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isJPG && !isPNG) {
      this.$message.error('上传图片只能是JPG和PNG格式!');
    }
    if (!isLt2M) {
      this.$message.error('上传图片大小不能超过2M');
    }
    if((isJPG || isPNG) && isLt2M){
      this.loading=true;
    }
    return (isJPG || isPNG) && isLt2M;
  }

  /* 上传超过个数的处理 */
  uploadLimit(uploadFileList, fileList) {
    if(fileList.length >= 0) {
      this.$message.error('最多支持上传5张！');
    }
  }
  /* 上传成功 */
  uploadSuccess(response, file, fileList){
    this.loading=false;
  }
  /* 上传失败 */
  uploadError(err, file, fileList){
    this.$message.error('图片上传失败，请您重新上传！');
    this.loading=false;
  }
}
